const Step = ({ title, isActive, isChecked, onClick }) => {
    return (
        <div className={`main-content__steps-item ${isActive ? "main-content__steps-item--current" : ""} ${isChecked ? "main-content__steps-item--checked" : ""}`} onClick={onClick} style={{ cursor: "pointer" }}>
            <div className="main-content__steps-title">
                <span>{title}</span>
            </div>
        </div>
    );
};

export default Step;
